import React from 'react'
import PropTypes from 'prop-types'

// application styles
import TextField from '@mui/material/TextField';
import SidebarItem, {MySidebarItem} from '../../../components/Sidebar/SidebarItem/SidebarItem'
// import {MySidebarItem} from '../../../components/Sidebar/SidebarItem/SidebarItem'
import Ax from '../../../hoc/Ax/Ax'

import theme from "../../../theme"

/**
 * returns an input with some other elements
 * @param propName
 * @param title
 * @param helperText
 * @param subtitle
 * @param divider
 * @param value
 * @param label
 * @param children
 * @param handleChange
 * @param valueRange
 * @param error
 * @returns {*}
 */
// const styles = {
//     textFieldFormLabel: {
//         '&$textFieldFocused': {
//             color: theme.palette.primary.dark,
//         },
//     },
//     textFieldFocused: {},
//     textFieldUnerline: {
//         '&:after': {
//             borderBottomColor: theme.palette.primary.dark,
//         },
//     },
// }

const sidebarItemInput = ({ propName, title, helperText, subtitle, divider, value, label, children, handleChange, valueRange, error, step, textFieldUnerline, textFieldFormLabel, textFieldFocused }) => (
    //   const { classes } = this.props}
    
    <Ax>
        <SidebarItem title={(title) ? title : false} subtitle={(subtitle) ? subtitle : false} divider={divider}>
            <TextField
                // InputProps={{
                //     classes: {
                //         underline: textFieldUnerline
                //     },
                // }}
                InputLabelProps={{
                    FormLabelClasses: {
                        root: textFieldFormLabel,
                        focused: textFieldFocused,
                    },
                }}
                error={error}
                variant={'standard'}
                type='number'
                label={label}
                value={value}
                onChange={event => handleChange(event, propName)}
                style={{color: theme.palette.primary.dark, width: '100%' }}
                helperText={(helperText) ? helperText : false}
                inputProps={{
                    classes: {
                        underline: textFieldUnerline
                    }, min: valueRange[0], max: valueRange[1], step: step
                }}
            />
            {(children)
            && (
                <div style={{ paddingTop: 20 }}>
                    {children}
                </div>
            )}
        </SidebarItem>
    </Ax>
)

 export const MysidebarItemInput = ({ propName, title, helperText, subtitle, divider, value, label, children, handleChange, valueRange, error, step, width,  textFieldUnerline, textFieldFormLabel, textFieldFocused }) => (
    <Ax>
        <MySidebarItem title={(title) ? title : false} subtitle={(subtitle) ? subtitle : false} divider={divider}>
            <TextField
                error={error}
                variant={'standard'}
                type='number'
                label={label}
                value={value}
                onChange={event => handleChange(event, propName)}
                style={{  width }}
                helperText={(helperText) ? helperText : false}
                 inputProps={{
                     classes: {
                         underline: textFieldUnerline
                     }, min: valueRange[0], max: valueRange[1], step: step
                 }}
                // InputProps={{
                //     classes: {
                //         underline: textFieldUnerline
                //     },
                // }}
                InputLabelProps={{
                    FormLabelClasses: {
                        root: textFieldFormLabel,
                        focused: textFieldFocused,
                    },
                }}
            />
            {(children)
            && (
                <div style={{ paddingTop: 20 }}>
                    {children}
                </div>
            )}
        </MySidebarItem>
    </Ax>
)


sidebarItemInput.defaultProps = {
    divider: false,
    title: false,
    subTitle: false,
    valueRange: false,
    error: false,
    step: 1,
}

MysidebarItemInput.defaultProps = {
    divider: false,
    title: false,
    subTitle: false,
    valueRange: false,
    error: false,
    step: 1,
    width: '100%'
}

sidebarItemInput.prototype = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    subtitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    helperText: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    handleChange: PropTypes.func.isRequired,
    children: PropTypes.node,
    divider: PropTypes.bool,
    hiddeTitle: PropTypes.bool,
    propName: PropTypes.string.isRequired,
    valueRange: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.bool,
    ]),
    error: PropTypes.bool,
    step: PropTypes.number
}

export default sidebarItemInput
